define('home/templates/channelsModuleItem',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.tile : stack1), depth0))
    + "\" class=\"tile__media border-radius-sm\" />\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "<div class=\"tile__overlay\">\n<h1 class=\"tile__name\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "</h1>\n</div>\n<img src=\"https://media.disquscdn.com/home/blank_tile.png\"\nclass=\"tile__media border-radius-sm\" />\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<div class=\"spacing-bottom-large\">\n<a href=\"/home/channel/"
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\" class=\"tile__wrapper -plain link-gray-dark\">\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.tile : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</a>\n<div class=\"channels-description -with-button align\">\n<p class=\"align__item spacing-right\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.description : stack1), depth0))
    + "</p>\n<div class=\"channels-description__button align__item\">\n<a class=\"button button-outline text-medium\"\nhref=\"/home/channel/"
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\">\n"
    + alias2(helpers.gettext.call(alias3,"Visit",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n</div>\n</div>\n";
},"useData":true})

});
